import { useEffect, useState } from 'react';

import validate from './SponsorsAddFormValidation';

import useSponsorData from '../../../state/sponsor/UseSponsorData';

import { BLANK_DATE_STRING, DEFAULT_ID } from '@usas/ui-web/utils/Constants';
import useForm from "@usas/ui-web/utils/UseForm";
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

const INITIAL_FORM_STATE = {
  sponsorId: DEFAULT_ID,
  sponsorName: '',
  effectiveDate: BLANK_DATE_STRING,
  expirationDate: BLANK_DATE_STRING
};

const useSponsorsAddForm = (onSubmitFormCallback, onIsDirtyChanged, onErrorCaught) => {
  const { environmentVariableState, SPONSOR_TYPE_SWIMSUIT_ID } = useEnvironmentVariableData();
  const { sponsorState, getSponsors } = useSponsorData();
  const { formState, errorState, isDirty, isSubmitting, setFormData, handleSubmit, updateFormState, onValueTextPairChanged,
    setErrors, resetForm
  } = useForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);
  const [optionsState, setOptionsState] = useState([]);

  useEffect(() => {
    async function loadSponsors() {
      try {
        if (environmentVariableState.isLoaded === true) {
          let sponsorOptionsState = null;

          if (sponsorState.areOptionsLoaded !== true) {
            sponsorOptionsState = await getSponsors();
          } else {
            sponsorOptionsState = sponsorState;
          }

          setOptionsState(sponsorOptionsState.options.filter((x) => x.sponsorTypeId === SPONSOR_TYPE_SWIMSUIT_ID || x.id === DEFAULT_ID));
        }
      } catch (e) {
        onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
      }
    }
    loadSponsors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState.isLoaded]);

  useEffect(() => {
    try { // reset form to initial state after add
      if (isDirty === false && isSubmitting === false) {
        setFormData(INITIAL_FORM_STATE);
      }

      if (onIsDirtyChanged) {
        onIsDirtyChanged(isDirty);
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty, isSubmitting]);

  return {
    sponsorOptions: optionsState,
    isDirty,
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    onValueTextPairChanged,
    resetForm
  };
};

export default useSponsorsAddForm;